import { CLEAR_ALL, LOGOUT } from '../../store/Types';

export const ALL_CARNET = 'ALL_CARNET';
export const LOADING_ALL_CARNET = 'LOADING_ALL_CARNET';
export const ACTIVO_CARNET = 'ACTIVO_CARNET';
export const PARAMS_CARNET = 'PARAMS_CARNET';
export const EDIT_CARNET = 'EDIT_CARNET';
export const STYLES_CARNET = 'STYLES_CARNET';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  stylesCarnet: null,
  params: {},
  editCarnet: null,
};

export const carnetReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_CARNET:
      return {
        ...state,
        all: action.payload.data,
      };
    case LOADING_ALL_CARNET:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_CARNET:
      return {
        ...state,
        activo: action.payload,
      };
    case STYLES_CARNET:
      return {
        ...state,
        stylesCarnet: action.payload,
      };
    case PARAMS_CARNET:
      return {
        ...state,
        params: action.payload,
      };
    case EDIT_CARNET:
      return {
        ...state,
        editCarnet: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
